<template>
  <svg t="1717034402088" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" fill="currentColor" p-id="28942" width="16" height="16"><path d="M961.6 238.4l-56-56L800 288V32h-80v256l-105.6-105.6-56 56 201.6 201.6 201.6-201.6zM377.6 496s-155.2 352-161.6 363.2c-6.4 14.4-24 20.8-36.8 19.2-12.8-3.2-19.2-14.4-19.2-30.4V352h187.2l32 80h281.6l-80-80h-147.2l-32-80H80v552c0 67.2 27.2 105.6 59.2 123.2 17.6 11.2 36.8 12.8 52.8 12.8h518.4c60.8 0 86.4-38.4 100.8-70.4 11.2-24 136-324.8 142.4-337.6L976 496H377.6z m360 360c-11.2 24-16 24-27.2 24H296l134.4-304h425.6s-110.4 264-118.4 280z"  p-id="28943"></path></svg>
</template>

<script setup lang="ts">

</script>

